module.exports = __webpack_public_path__ + "img/personal-diverso.26162026.png";